export default __webpack_public_path__ + "static/media/contact.96231e21.svg";